import { types } from 'mobx-state-tree';
import { createContext, useContext } from 'react';
import { Client } from 'urql';

import { GlobalVariables } from 'stores/env';
import { createMarketPlaceStore, MarketPlaceStore } from 'stores/marketPlaceStore';
import { createOrgStore, OrgStore } from 'stores/orgStore';
import { createPageStore, PageStore } from 'stores/pageStore';
import { createUserStore, UserStore } from 'stores/userStore';

const RootStore = types.model('RootStore', {
  orgStore: OrgStore,
  userStore: UserStore,
  pageStore: PageStore,
  marketPlaceStore: MarketPlaceStore,
});

export const createRootStore = (urqlClient: Client) => {
  const orgStore = createOrgStore();
  const userStore = createUserStore();
  const pageStore = createPageStore();
  const marketPlaceStore = createMarketPlaceStore();
  const env: GlobalVariables = { urqlClient };
  return RootStore.create({ orgStore, userStore, pageStore, marketPlaceStore }, env);
};

type TRootStore = ReturnType<typeof createRootStore>;
const RootStoreContext = createContext<TRootStore>({} as TRootStore);

export const RootStoreProvider = RootStoreContext.Provider;
export const useStores = () => useContext(RootStoreContext);
